import axiosClient from '../axiosClient';
import { OtpProviderEndpoints } from '../endpoints/otpProvider';
import { OtpProviderResponse } from '../../types/api/response/otpproviderresponse';

export const OtpProviderService = {
  async listOtpProviders(): Promise<OtpProviderResponse[]> {
    const res = await axiosClient.get<OtpProviderResponse[]>(OtpProviderEndpoints.LIST);
    return res.data;
  },

  async activateOtpProvider(id: number): Promise<OtpProviderResponse[]> {
    const url = OtpProviderEndpoints.ACTIVATE.replace(':id', id.toString());
    const res = await axiosClient.put<OtpProviderResponse[]>(url);
    return res.data;
  },
};
